import React from 'react'
import { Tab } from 'semantic-ui-react'
import AnggaranRealisasi41 from './AnggaranRealisasi41'
import AnggaranRealisasi42 from './AnggaranRealisasi42'
import AnggaranRealisasi43 from './AnggaranRealisasi43'

const panes = [

   { 
      menuItem: 'Rekening 4.1', 
      render: () => <Tab.Pane attached={false}><AnggaranRealisasi41 /></Tab.Pane> 
   },
   { 
      menuItem: 'Rekening 4.2', 
      render: () => <Tab.Pane attached={false}><AnggaranRealisasi42 /></Tab.Pane> 
   },
   { 
      menuItem: 'Rekening 4.3', 
      render: () => <Tab.Pane attached={false}><AnggaranRealisasi43 /></Tab.Pane> 
   }

]

const AnggaranRealisasiRekening = () => (
  <Tab menu={{ pointing: true }} panes={panes} />
)

export default AnggaranRealisasiRekening;


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_report/AnggaranRealisasiRekening.js